import angular from 'angular';

export default angular.module('asRangeLabel', []).component('asRangeLabel', {
    template: require('./asRangeLabel.component.html'),
    bindings: {
        api: '=?',
        options: '=?',
        start: '<',
        end: '<',
        centerLabel: '@',
        itemLabel: '@'
    },
    controller(textResources) {
        var vm = this;

        vm.$doCheck = () => {
            if (!vm.options.manualReload) {
                vm.updateLocalRange();
            }
        };

        vm.calculateRange = () => {
            return Math.abs(vm.localStart - vm.localEnd);
        };

        vm.hasValidBindings = () => {
            return isFinite(vm.localStart) && isFinite(vm.localEnd);
        };

        vm.initOptions = () => {
            vm.options = vm.options || {};

            if (vm.options.manualReload === undefined) {
                vm.options.manualReload = false;
            }
        };

        vm.initLabels = () => {
            vm.centerLabel = vm.centerLabel || ' - ';
            vm.itemLabel = vm.itemLabel || textResources.itemLabel;
        };

        vm.areBothEndsZero = () => {
            return vm.localStart === 0 && vm.localEnd === 0;
        };

        vm.updateLocalRange = () => {
            vm.localStart = vm.start;
            vm.localEnd = vm.end;
        };

        vm.renderFrontText = () => {
            if (vm.areBothEndsZero()) {
                return;
            }

            var text = vm.itemLabel;
            if (vm.calculateRange() > 1) {
                text += `s`;
            }
            return `${text} `;
        };

        vm.renderRange = () => {
            if (vm.areBothEndsZero()) {
                return 0;
            }

            var text = vm.localStart;
            if (vm.calculateRange() !== 0) {
                text += `${vm.centerLabel}${vm.localEnd}`;
            }
            return text;
        };

        vm.renderEndText = () => {
            if (vm.areBothEndsZero()) {
                return ` ${vm.itemLabel}s`;
            }
        };

        vm.$onInit = () => {
            vm.initOptions();
            vm.initLabels();
            vm.api = {
                reload: vm.updateLocalRange
            };

            if (!vm.options.manualReload) {
                vm.updateLocalRange();
            }
        };
    }
});



// WEBPACK FOOTER //
// ./modules/shared/asRangeLabel/asRangeLabel.component.js